function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 59,
  height: 59,
  rx: 29.5,
  fill: "#C4C4C4",
  stroke: "#E4E4E4",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M44 45V41.1111C44 39.0483 43.1571 37.07 41.6569 35.6114C40.1566 34.1528 38.1217 33.3333 36 33.3333H20C17.8783 33.3333 15.8434 34.1528 14.3431 35.6114C12.8429 37.07 12 39.0483 12 41.1111V45M36 17.7778C36 22.0733 32.4183 25.5556 28 25.5556C23.5817 25.5556 20 22.0733 20 17.7778C20 13.4822 23.5817 10 28 10C32.4183 10 36 13.4822 36 17.7778Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57 35C65.2843 35 72 28.2843 72 20C72 11.7157 65.2843 5 57 5C48.7157 5 42 11.7157 42 20C42 28.2843 48.7157 35 57 35Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M56.6667 31.3333C63.11 31.3333 68.3333 26.11 68.3333 19.6667C68.3333 13.2233 63.11 8 56.6667 8C50.2233 8 45 13.2233 45 19.6667C45 26.11 50.2233 31.3333 56.6667 31.3333Z",
  fill: "#FFCC00"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M58.24 14.8V26H56.656V16.192H54.128V14.8H58.24Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd",
  x: 38,
  y: 3,
  width: 38,
  height: 38,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.06 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "multiply",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.06 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "multiply",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})));

var SvgSecondStepIcon = function SvgSecondStepIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 61,
    viewBox: "0 0 76 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecondStepIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/second-step-icon.cbc11db1.svg";
export { ForwardRef as ReactComponent };